export default function validationUpdateDemande(response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('IN_OT') === 0) {
      messages.push({ message: 'listeDemande.messages.error.inOt' });
    }
    if (message.indexOf('NOT_SALE') === 0) {
      messages.push({ message: 'listeDemande.messages.error.notSale' });
    }
    if (message.indexOf('LINE_NOT_EXIST') === 0) {
      messages.push({ message: 'listeDemande.messages.error.lineNotExist' });
    }
    if (message.indexOf('DEMANDE_LOGISTIQUE_SEL_PRODUIT_NOT_AVAILABLE') === 0) {
      messages.push({ message: 'listeDemande.messages.error.produitNotAvailable' });
    }
  });
}

export function validationDesaffectation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const errorMessage = error.message;
    if (errorMessage.indexOf('ALREADY_IN_OT') === 0) {
      messages.push({
        message: 'listeDemande.desaffecter.messages.error.alReadyInOt',
      });
    }
  });
}
